import { Article, FileUpload, History } from '@mui/icons-material';
import { FC } from 'react';
import Routes from 'routes';
import { useLanguage } from 'context/AppContext';
import * as BaseStyles from '../DataUpload.styles';
import DataUploadMenuLink from './DataUploadMenuLink';
import * as Styles from './DataUploadNavBar.styles';

interface DataUploadNavBarParams {
  handleOpenTemplatesDialog: () => void;
}

const DataUploadNavBar: FC<DataUploadNavBarParams> = ({ handleOpenTemplatesDialog }) => {
  const [language] = useLanguage();

  return (
    <Styles.NavBar>
      <Styles.Title variant="h6">{language.DataUpload.title}</Styles.Title>
      <Styles.Nav>
        <Styles.NavList>
          <DataUploadMenuLink
            path={Routes.DataUploadList.path}
            text={language.DataUpload.menu.uploadList}
            startIcon={<History />}
          />
          <DataUploadMenuLink
            path={Routes.DataUpload.path}
            text={language.DataUpload.menu.upload}
            startIcon={<FileUpload />}
          />
          <BaseStyles.DataButton variant="contained" startIcon={<Article />} onClick={handleOpenTemplatesDialog}>
            {language.DataUpload.menu.templates}
          </BaseStyles.DataButton>
        </Styles.NavList>
      </Styles.Nav>
    </Styles.NavBar>
  );
};

export default DataUploadNavBar;
